// extracted by mini-css-extract-plugin
export default {"fsQuantitySelector":"quantity-selector-module--fs-quantity-selector--645b8"};